import { ElementType, IElement } from '../../../models/Element';

export type PluginNoHighlightLeftImageInfo = IElement & {
  image: string;
  image_alt: string;
  heading: string;
  description: string;
  button_title: string;
  button_url: string;
};

export const defaultPluginNoHighlightLeftImageInfo: PluginNoHighlightLeftImageInfo =
  {
    id: 0,
    name: ElementType.PLUGIN_NO_HIGHLIGHT_LEFT_IMAGE_INFO,
    image: '',
    image_alt: '',
    heading: 'Als makelaar kun je niet zonder deze plugin',
    description:
      'De "WordPress Makelaars plugin" is onmisbaar voor de makelaar. Niet alleen toont de plugin het actuele aanbod, ook scoort de website beter in zoekmachines zoals Google. Omdat alle objecten op de website staan, worden deze door zoekmachines beter geindexeerd.',
    button_title: 'Button',
    button_url: '',
  };
